/*! myaleph-tile-tap-guard.js — general collection tile tap guard
 * Image/title tap → PDP (not bag). Corner + chip only → add-to-cart.
 * Applies to ALL product tiles (incl. Juliana / Leah phone charms / Galet).
 * Product-specific Juliana/Leah hide (FIX3/FIX5) intentionally removed Sep22 restore.
 */
(function () {
  if (window.__myalephTileTapGuard) return;
  window.__myalephTileTapGuard = true;
  window.__myalephBagDiag = window.__myalephBagDiag || [];

  function log(event, data) {
    try { window.__myalephBagDiag.push({ t: Date.now(), event: event, path: location.pathname, ...(data || {}) }); } catch (e) {}
  }


  function isQaButton(t) {
    return !!(t && t.closest && t.closest('[class*="quick-actions-toolbar"] button[data-add-to-cart], [class*="quick-actions-toolbar"] button.myaleph-qa-btn, [class*="quick-actions-toolbar"] button.stain-button-white'));
  }

  // Arm allow only when gesture starts on the corner + button
  var allowQuickAdd = false, allowUntil = 0;
  document.addEventListener('pointerdown', function (e) {
    if (isQaButton(e.target)) {
      allowQuickAdd = true;
      allowUntil = Date.now() + 3000;
      log('arm_quick_add');
    } else {
      allowQuickAdd = false;
      allowUntil = 0;
    }
  }, true);

  // Block toolbar form submit unless armed by + button (prevents image-tap → bag)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.closest) return;
    if (!form.closest('product-grid-item')) return;
    if (!form.closest('[class*="quick-actions-toolbar"]')) return;
    if (allowQuickAdd && Date.now() <= allowUntil) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    log('blocked_toolbar_submit_not_from_plus');
  }, true);
})();
